<template>
  <div class="graph-card" role="graph" title="A Z MERIT % Passing" aria-describedby="azmerit-description">
    <div class="graph-card-header" :style="{'background-color': this.headerColor}">
      <div class="g-heading">
        <h2>AzMERIT % Passing</h2>
        <p>{{ data.year }}</p>
      </div>
      <div
        class="tooltip-icon"
        tabindex="0"
        @mouseenter="toggleTooltip(1)"
        @mouseleave="toggleTooltip(0)"
        @keydown.enter="toggleTooltip(1)"
        @keyup.enter="toggleTooltip(0)">
      </div>
    </div>
    <div class="graph-card-body" :style="{'background-color': this.bodyColor}">
      <cmps-bar :data="chartData" :options="chartOptions" :styles="stylesObject" aria-hidden="true"></cmps-bar>
      <div class="tooltip-text" ref="tooltip" aria-hidden="true">
        <p id="azmerit-description">AzMERIT is a test given to 3rd - 12th grade students, and is designed to measure student learning and progress towards readiness for college or career. The test includes sections on English Language Arts and Math.</p>
      </div>
      <table class="sr-only">
        <thead>
          <tr>
            <th>Year</th>
            <th>Math</th>
            <th>English Language Arts</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ this.data.school_year }}</td>
            <td>{{ this.data.passing_MAT }} % passing</td>
            <td>{{ this.data.passing_ELA }} % passing</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> <!-- end graph-card -->
</template>

<script>
  import Bar from './charts/Bar.vue'

  export default {
    components: {
      cmpsBar: Bar
    },
    props: ['data', 'headerColor', 'bodyColor'],

		data() {
			return {
        chartData: {
          datasets: [
            {
              data: [this.data.math, this.data.ela],
              backgroundColor: ['#8ac', '#db9'],
              borderColor: 'white',
              borderWidth: 1,
            }
          ],
          labels: ['Math', 'English & Language Arts']
        },
        chartOptions: {
          barPercentage: 0.5,
          // barThickness: 3,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              gridLines: {
                color: '#000',
              },
              ticks: {
                fontColor: '#000',
                min: 0,
                max: 100,
                stepSize: 20
              }
            }],
            xAxes: [{
              gridLines: {
                color: '#000'
              },
              ticks: {
                fontColor: '#000'
              }
            }]
          },
          plugins: {
            deferred: {
              yOffset: '75%',
              delay: 500
            }
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return '  ' +
                       data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '%';
              }
            }
          }
        },
        stylesObject: {
          // height: '350px',
          position: 'relative'
        }
      }
		},
    methods: {
      toggleTooltip(value) {
        this.$refs.tooltip.style.left = value === 1 ? '0' : '99999px'
        this.$refs.tooltip.style.opacity = value
      }
    }
  }
</script>

<style lang="scss" scoped>
@import 'src/assets/_graphs.scss';
</style>
